// import { HiLocationMarker } from "react-icons/hi";

// import { Button, IconWithBorder } from "components";

// import { Rating } from "components/Rating";

// import "./DoctorCard.scss";

// import doctorDefaultMale from "assets/icons/doctor-default-male.png";
// import doctorDefaultFemale from "assets/icons/doctor-default-female.png";
// import { generateImageLink } from "utils";

// interface DoctorCardProps {
//   image: string;
//   title: string;
//   subtitle: string;
//   location: string | string[];
//   rating?: number;
//   rating_quantity?: number;
//   setShowDoctorsModal: () => void;
//   gender: string;
// }

// export const DoctorCard = ({
//   image,
//   gender,
//   title,
//   subtitle,
//   location,
//   rating,
//   rating_quantity,
//   setShowDoctorsModal
// }: DoctorCardProps) => {
//   let doctorImage = generateImageLink({ imageId: image });

//   if (!image && gender === "male") {
//     doctorImage = doctorDefaultMale;
//   } else if (!image && gender === "female") {
//     doctorImage = doctorDefaultFemale;
//   }

//   return (
//     <div className="doctor-card">
//       <div className="doctor-card__image-wrapper">
//         <img
//           onClick={setShowDoctorsModal}
//           className="doctor-card__image"
//           alt={image || ""}
//           src={doctorImage}
//           loading="lazy"
//         />
//       </div>
//       <div className="content">
//         <div onClick={setShowDoctorsModal} className="content__title">
//           {title}
//         </div>
//         <div className="content__subtitle">{subtitle}</div>
//         <div className="content__location">
//           <IconWithBorder>
//             <HiLocationMarker />
//           </IconWithBorder>
//           <div className="content__location--text">{location}</div>
//         </div>
//         <Rating
//           point={rating ? rating.toString() : "0"}
//           quantity={rating_quantity ? rating_quantity.toString() : "0"}
//         />
//         {/* <Button
//           onClick={setShowDoctorsModal}
//           withHover
//           className="content__button"
//         >
//           ჩაეწერეთ მიღებაზე
//         </Button> */}
//       </div>
//     </div>
//   );
// };

import { HiLocationMarker } from "react-icons/hi";
import { Button, IconWithBorder } from "components";
import { Rating } from "components/Rating";

import "./DoctorCard.scss";

import doctorDefaultMale from "assets/icons/doctor-default-male.png";
import doctorDefaultFemale from "assets/icons/doctor-default-female.png";
import { generateImageLink } from "utils";
import { Link } from "components/LanguageChanger";

interface DoctorCardProps {
  image: string;
  title: string;
  subtitle: string;
  location: string | string[];
  rating?: number;
  rating_quantity?: number;
  setShowDoctorsModal?: () => void;
  gender: string;
  href?: string; // New prop for link
}

export const DoctorCard = ({
  image,
  gender,
  title,
  subtitle,
  location,
  rating,
  rating_quantity,
  setShowDoctorsModal,
  href, // Added href prop
}: DoctorCardProps) => {
  let doctorImage = generateImageLink({ imageId: image });

  if (!image && gender === "male") {
    doctorImage = doctorDefaultMale;
  } else if (!image && gender === "female") {
    doctorImage = doctorDefaultFemale;
  }

  // Dynamic Wrapper: Use <a> if href is provided, otherwise <div>
  const Wrapper: any = href ? Link : "div";

  return (
    <Wrapper
      className="doctor-card"
      {...(href ? { to: href } : { onClick: setShowDoctorsModal })}
    >
      <div className="doctor-card__image-wrapper">
        <img
          onClick={!href ? setShowDoctorsModal : undefined}
          className="doctor-card__image"
          alt={image || ""}
          src={doctorImage}
          loading="lazy"
        />
      </div>
      <div className="content">
        <div
          onClick={!href ? setShowDoctorsModal : undefined}
          className="content__title"
        >
          {title}
        </div>
        <div className="content__subtitle">{subtitle}</div>
        <div className="content__location">
          <IconWithBorder>
            <HiLocationMarker />
          </IconWithBorder>
          <div className="content__location--text">{location}</div>
        </div>
        <Rating
          point={rating ? rating.toString() : "0"}
          quantity={rating_quantity ? rating_quantity.toString() : "0"}
        />
      </div>
    </Wrapper>
  );
};
